import {
    Card, Grid
} from "@mui/material";
import ReportFilterCard from "app/components/Card/report/ReportFilterCard";
import ReportSubjectGroupsTable from "app/components/Table/reports/ReportSubjectGroupsTable";
import React, { useState } from "react";
import { getReportSubjectGroups, generateSubjectGroupsPDFAPI } from 'api/report';

const ReportSubjectGroupsPage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [lastFilter, setLastFilter] = useState(null);

    const setFilterData = (data) => {
        setData(data);
    };

    const handleResultListSubjectGroups = async (filters) => {
        setLoading(true);
        try {
            const res = await getReportSubjectGroups(filters);
            setFilterData(res.data.data);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const generateSubjectGroupsPDFApi = async () => {
        if (!lastFilter) return;
        setLoading(true);
        try {
            await generateSubjectGroupsPDFAPI(lastFilter);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Grid container sx={{ marginBottom: 4 }}>
                <Grid item xs={12} md={12}>
                    <ReportFilterCard
                        title="Kararların Konularına Göre Dağılımı"
                        setFilterData={setFilterData}
                        reportType={1}
                        handleResultList={handleResultListSubjectGroups}
                        generatePDFApi={generateSubjectGroupsPDFApi}
                        showUnitFilter={true}
                    />
                </Grid>
            </Grid>

            {data.length > 0 && (
                <Card sx={{ padding: 2 }}>
                    <ReportSubjectGroupsTable data={data} />
                </Card>
            )}
        </React.Fragment>
    );
};

export default ReportSubjectGroupsPage;

